module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', [_c('div', {
    staticClass: "footer-inner"
  }, [_c('div', {
    staticClass: "logo"
  }, [_c('router-link', {
    attrs: {
      "to": '/'
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/logogrey.svg")
    }
  })])], 1), _vm._v(" "), _c('nav', {
    staticClass: "footer-menu"
  }, [_c('li', {
    staticClass: "desktop"
  }, [_c('router-link', {
    attrs: {
      "to": '/browse'
    }
  }, [_vm._v("Locations")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": '/contact'
    }
  }, [_vm._v("Contact")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": '/submitproperty'
    }
  }, [_vm._v("List Your Property")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": '/about'
    }
  }, [_vm._v("About")])], 1)]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "copyright"
  }, [_vm._v("\n        All content © " + _vm._s((new Date()).getFullYear()) + " Production Locations\n      ")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contact"
  }, [_c('a', {
    staticClass: "phone",
    attrs: {
      "href": "tel:3238740404"
    }
  }, [_vm._v("(323) 874-0404")]), _vm._v(" "), _c('a', {
    staticClass: "email",
    attrs: {
      "href": "mailto: office@productionlocations.com"
    }
  }, [_vm._v("office@productionlocations.com")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "segments"
  }, [_c('div', {
    staticClass: "corporateaddress"
  }, [_c('h4', [_vm._v("Corporate Mailing Address")]), _vm._v(" "), _c('p', [_vm._v("9663 Santa Monica Blvd. #490"), _c('br'), _vm._v("\n              Beverly Hills, CA 90210")])]), _vm._v(" "), _c('div', {
    staticClass: "officeaddress"
  }, [_c('h4', [_vm._v("Downtown Office")]), _vm._v(" "), _c('p', [_vm._v("756 S Broadway #1110"), _c('br'), _vm._v("Los Angeles, CA 90014")])]), _vm._v(" "), _c('div', {
    staticClass: "social"
  }, [_c('h4', [_vm._v("Connect")]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "facebook",
    attrs: {
      "href": "https://www.facebook.com/ProductionLocations"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/facebook.svg")
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "twitter",
    attrs: {
      "href": "https://twitter.com/PLocations"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/twitter.svg")
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "instagram",
    attrs: {
      "href": "https://www.instagram.com/productionlocations/"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/instagram.svg")
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "linkedin",
    attrs: {
      "href": "https://www.linkedin.com/company/production-locations?trk=ppro_cprof"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/linkedin.svg")
    }
  })])])]), _vm._v(" "), _c('div')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1d0ea153","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MainFooter.vue
// module id = 181
// module chunks = 1